<template>
  <FormContainer :submit="onSubmit">
    <v-layout v-if="apiError" wrap row>
      <v-flex xs12>
        <BaseAlert :hg-value="true" hg-type="error">
          This username or password are incorrect
        </BaseAlert>
      </v-flex>
    </v-layout>
    <v-layout row wrap>

      <v-flex xs12>
        <TextInputCommon
          v-model="model.username"
          :validations="{ required: true }"
          display-name="Username"
          ref="username-input" />
      </v-flex>

      <v-flex xs12>
        <!-- password field !-->
        <PasswordField
          v-model="model.password"
          v-validate="{ required: true }"
          :error-messages="errors.collect('password')"
          :hide-details="true"
          label="Password"
          name="password"
          outline />
      </v-flex>

      <v-flex xs12>
        <p class="content-leadin">
          <a :href="forgotPasswordLink" class="content-link" target="_blank">
            Forgot your username or password?
          </a>
        </p>
      </v-flex>

      <v-flex xs12>
        <p class="content-leadin">
          Don't have an account?
          <router-link :to="signupLink" class="content-link">Sign Up</router-link>
        </p>
      </v-flex>
    </v-layout>

    <StepNavigation :continue-disabled="submitButtonDisabled" submit-mode @submit="onSubmit" />
  </FormContainer>
</template>

<script>
import { Components, Mixins } from '@spectorasoftware/homegauge-vue';

import RouteNames from '@/router/constants/route-names';
import TextInputCommon from '@/components/common/TextInputCommon.vue';
import FormContainer from '@/components/FormContainer.vue';
import StepNavigation from '@/components/StepNavigation.vue';

const { BaseAlert, PasswordField } = Components;
const { FormValidationsMixin } = Mixins;

export default {
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    BaseAlert,
    FormContainer,
    PasswordField,
    StepNavigation,
    TextInputCommon,
  },
  mixins: [FormValidationsMixin],
  props: {
    apiError: {
      type: Boolean,
      default: false,
    },
    apiLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {
        password: '',
        username: '',
      },
      showError: false,
    };
  },
  computed: {
    forgotPasswordLink() {
      return `${process.env.VUE_APP_ACCOUNT_URL}/forgot-password`;
    },
    signupLink() {
      return {
        name: RouteNames.AppointmentCreateAccount,
      };
    },
    submitButtonDisabled() {
      return !!(!this.formRequiredFieldsAreValid
        || this.formHasErrors
        || this.apiLoading);
    },
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$validator.validateAll();
      if (isValid) {
        this.$emit('submit', { ...this.model });
      }
    },
  },
};
</script>
